export const ROUTES = {
  codingDashboard: {
    parentPath: "/clinical-coding",
    slug: "coding-dashboard",
    route: "/clinical-coding/coding-dashboard",
  },
  gapAnalysis: {
    parentPath: "/clinical-coding",
    slug: "gap-analysis",
    route: "/clinical-coding/gap-analysis",
  },
};
